<script setup lang="ts" name="OrganisationHomeIndex">
import { computed } from 'vue';

import { ORGANISATION_TYPE } from '~/constants';
import { useProfileStore } from '~/store';

import HomeIndex from '~/components/HomeIndex.vue';
import OrganisationHomeAgency from '~/components/OrganisationHomeAgency.vue';

import type { IOrganisation } from '~/types';

const { organisationId, organisation } = defineProps<{
  organisationId: OrganisationId;
  organisation: IOrganisation;
}>();

const profile = computed(() => useProfileStore().profile);

const page = computed(() => ({
  title: `Hello, ${profile.value?.firstName || 'There'}`,
}));
</script>

<template>
  <OrganisationHomeAgency
    v-if="organisation.type === ORGANISATION_TYPE.PORT_AGENCY"
    :organisationId="organisationId"
    :page="page"
  />
  <HomeIndex
    v-else
    :organisationId="organisationId"
    :organisation="organisation"
    :page="page"
  />
</template>
